import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const AWARDS = [
  {
    id: 1,
    title: 'Best Customer Service Platform',
    year: '2026',
    image: '/assets/images/gen/award-support.svg',
    description: 'Recognised for WhatsApp-based support and personalised player assistance that answers in minutes.',
  },
  {
    id: 2,
    title: 'Most Trusted Gaming Platform',
    year: '2025',
    image: '/assets/images/gen/award-fair-play.svg',
    description: 'Awarded for the highest standards of security, transparency and dispute resolution.',
  },
  {
    id: 3,
    title: 'Excellence in Payment Security',
    year: '2024',
    image: '/assets/images/gen/award-fast-payout.svg',
    description: 'Honoured for advanced payment safeguards and the instant payout system behind five-minute cashouts.',
  },
  {
    id: 4,
    title: 'Community Choice Award',
    year: '2024',
    image: '/assets/images/gen/award-community.svg',
    description: 'Voted by players for innovation in mobile gaming and pioneering WhatsApp integration.',
  },
];

const PRESS = [
  {
    title: 'Featured in Economic Times',
    description: "Nitin's approach to customer service through WhatsApp highlighted as an industry game-changer.",
    icon: 'Newspaper',
  },
  {
    title: 'Gaming industry leadership',
    description: "Recognised among India's notable gaming operators for service standards by Business Today.",
    icon: 'TrendingUp',
  },
  {
    title: 'Customer satisfaction excellence',
    description: '99.2% satisfaction in an independent survey by the Gaming Research Institute.',
    icon: 'Star',
  },
  {
    title: 'Technology innovation award',
    description: 'Recognised by the Indian Software Association for platform engineering breakthroughs.',
    icon: 'Cpu',
  },
];

const AwardsRecognitionSection = () => (
  <section className="relative overflow-hidden py-24">
    <span className="aurora right-[-10%] top-[6%] h-96 w-96 bg-royal-gold/25" aria-hidden="true" />

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <span className="badge-pill"><Icon name="Award" size={13} /> Recognition</span>
        <h2 className="mt-6 font-heading text-display font-bold text-white">
          Trophies are nice. <span className="gold-text">Payouts matter more.</span>
        </h2>
        <p className="mt-4 text-body-lg text-white/60">
          We still keep the awards on the wall — mostly because they were won for the things players actually feel:
          speed, safety and someone answering the message.
        </p>
      </div>

      <div className="perspective mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {AWARDS.map((a, i) => (
          <article key={a.id} className="card-3d animate-rise overflow-hidden" style={{ animationDelay: `${i * 80}ms` }}>
            <Image src={a.image} alt={a.title} className="h-36 w-full object-cover" />
            <div className="p-5">
              <span className="rounded-full bg-royal-gold/12 px-2.5 py-0.5 text-[0.62rem] font-semibold text-royal-gold">
                {a.year}
              </span>
              <h3 className="mt-3 font-display text-base font-semibold text-white">{a.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-white/50">{a.description}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-8 grid gap-5 md:grid-cols-2">
        {PRESS.map((p) => (
          <div key={p.title} className="card-flat flex gap-4 p-6">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white/[0.07]">
              <Icon name={p.icon} size={20} color="#F0C24B" />
            </span>
            <div>
              <h3 className="font-display text-sm font-semibold text-white">{p.title}</h3>
              <p className="mt-1 text-sm text-white/55">{p.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default AwardsRecognitionSection;
